/**
 * Click-to-dial. The phone lives in the desk (a separate page that owns the Amazon Connect
 * softphone), so the CRM hands it the number: it opens the desk with `?dial=<E.164>` in the one
 * named tab the desk runs in, which focuses the desk if it is already open rather than starting a
 * second softphone (Connect refuses two for one agent). The desk reads the parameter and fills
 * its dialpad; the agent presses Call. See docs/PHONE-INTEGRATION.md, "Click to dial".
 */
import { config } from "../config";

export const DESK_WINDOW = "tl-agent-desk";

export function dialUrl(e164: string): string {
  return `${config.deskUrl}/?dial=${encodeURIComponent(e164)}`;
}

export function dial(e164: string): void {
  window.open(dialUrl(e164), DESK_WINDOW);
}
